import Loading from '@/components/Shared/Loading';
import { useTokenState } from '@/store/localStorage/useTokenState';
import { loadEntryToRedirect } from '@/store/notifications/operations/loadEntryToRedirect';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function EntryRedirect() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [token] = useTokenState();
  const { eid } = useParams();

  useEffect(() => {
    dispatch(loadEntryToRedirect({ eid, location, token, navigate }));
  }, [token, eid, location, navigate, dispatch]);

  return <Loading />;
}
